export class ValidationError extends Error {
    constructor(message : string) {
        super(message) // (1)
        this.name = "ValidationError" // (2)
    }
}

// class TooShortError extends ValidationError {
//     constructor(property : string) {
//         super("No property: " + property);
//         this.name = "PropertyRequiredError";
//         this.property = property;
//       }
// }